import {useTranslation} from 'react-i18next';
import {useModalControls} from '@chekin/guestapp-ui-kit';
import QuestionMarkAndText from 'components/common/QuestionMarkAndText';
import {ResponsiveSheet} from '@chekinapp/ui';
import {ModalSheetContainer, WhyDataRequiredText, ViewPrivacyPolicyLink} from './styled';

type Props = {
  className?: string;
};
export const WhyDataRequired = ({className}: Props) => {
  const {t} = useTranslation();
  const {
    isOpen: isSignatureModal,
    openModal: openSignatureModal,
    closeModal: closeSignatureModal,
  } = useModalControls();

  return (
    <>
      <QuestionMarkAndText
        className={className}
        text={t('why_all_this_data_is_required')}
        onClick={openSignatureModal}
        iconSize={19}
      />
      <ResponsiveSheet
        open={isSignatureModal}
        onClose={closeSignatureModal}
        title={t('why_all_this_data_is_required')}
        closeOnOverlayClick
        contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
        titleClassName="mb-6"
      >
        <ModalSheetContainer>
          <WhyDataRequiredText>{t('according_to_the_local_law')}</WhyDataRequiredText>
          <WhyDataRequiredText>{t('completing_online_checkin')}</WhyDataRequiredText>
          <WhyDataRequiredText>{t('personal_data_handling')}</WhyDataRequiredText>
          <ViewPrivacyPolicyLink
            href={t('guest_privacy_policy_link')}
            label={t('view_privacy_policy')}
          />
        </ModalSheetContainer>
      </ResponsiveSheet>
    </>
  );
};
